import dayjs from 'dayjs';
import {get} from 'lodash';

/**
 * Parolni almashtirish talab qilinadimi: mustChangePassword, passwordChangedAt yo'q
 * yoki oxirgi o'zgarishdan beri 1 oydan ortiq vaqt o'tgan.
 */
export function requiresPasswordChange(user) {
    if (!user) {
        return false;
    }
    if (get(user, 'mustChangePassword') === true) {
        return true;
    }
    const changedAt = get(user, 'passwordChangedAt');
    if (changedAt == null || changedAt === '') {
        return true;
    }
    const d = dayjs(changedAt);
    if (!d.isValid()) {
        return true;
    }
    return dayjs().isAfter(d.add(1, 'month'));
}
